import axios from "axios";
import { getCookie } from "typescript-cookie";

const baseURL = process.env.REACT_APP_API_URL;
const TIMEOUT = 15000;

export const axiosBuyer = axios.create({
  baseURL,
  timeout: TIMEOUT,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});
export const axiosReseller = axios.create({
  baseURL,
  timeout: TIMEOUT,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});
export const axiosSupplier = axios.create({
  baseURL,
  timeout: TIMEOUT,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});
export const axiosPublic = axios.create({
  baseURL,
  timeout: TIMEOUT,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

axiosPublic.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 500) {
      window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/500-error`;
    }

    return Promise.reject(error);
  }
);

axiosBuyer.interceptors.request.use(
  (config) => {
    const token = getCookie("buyerToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosReseller.interceptors.request.use(
  (config) => {
    const token = getCookie("resellerToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosSupplier.interceptors.request.use(
  (config) => {
    const token = getCookie("supplierToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
